import type { DersdinleUser } from "@/lib/api";

type User = DersdinleUser;

// Kayıt sırasında user_metadata'a yazılan alanlardan gerçek kimliği çözer.
export interface StudentIdentity {
  name: string;
  initials: string;
  grade: string;
  city: string;
}

function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "";
  if (parts.length === 1) return parts[0].slice(0, 1).toLocaleUpperCase("tr-TR");
  return (parts[0][0] + parts[parts.length - 1][0]).toLocaleUpperCase("tr-TR");
}

/**
 * "5. Sınıf", "12. Sınıf (YKS)", "Mezun" gibi insan-okunur sınıf adlarından
 * soru havuzuyla eşleşebilen sayısal sınıf seviyesini çıkarır.
 * Örnek: "5. Sınıf" -> "5", "12. Sınıf (YKS)" -> "12", "Mezun" -> "12".
 */
export function extractGradeLevel(grade: string): string | null {
  if (!grade) return null;
  if (/mezun/i.test(grade)) return "12";
  const m = grade.match(/(\d+)/);
  return m ? m[1] : null;
}

export function resolveStudentIdentity(user: User | null): StudentIdentity {
  const meta = user?.user_metadata ?? {};
  const fallbackName = user?.email ? user.email.split("@")[0] : "";
  const name = String(meta.ad_soyad || fallbackName || "Öğrenci");
  return {
    name,
    initials: initialsOf(name),
    grade: String(meta.sinif || ""),
    city: String(meta.sehir || ""),
  };
}

// Öğretmen kimliği — kayıt sırasında user_metadata'a yazılan alanlardan çözer.
export interface TeacherIdentity {
  name: string;
  initials: string;
  branch: string;
  city: string;
  email: string;
  phone: string;
  district: string;
  address: string;
  birthDate: string;
  gender: string;
  experience: string;
  education: string;
  bio: string;
}

export function resolveTeacherIdentity(user: User | null): TeacherIdentity {
  const meta = user?.user_metadata ?? {};
  const fallbackName = user?.email ? user.email.split("@")[0] : "";
  const name = String(meta.ad_soyad || fallbackName || "Öğretmen");
  return {
    name,
    initials: initialsOf(name),
    branch: String(meta.brans || ""),
    city: String(meta.sehir || ""),
    email: user?.email ?? "",
    phone: String(meta.telefon || ""),
    district: String(meta.ilce || ""),
    address: String(meta.adres || ""),
    birthDate: String(meta.dogum_tarihi || ""),
    gender: String(meta.cinsiyet || ""),
    experience: String(meta.deneyim || ""),
    education: String(meta.egitim || ""),
    bio: String(meta.biyografi || ""),
  };
}

// Panel kimliği — üst bar ve kenar çubuğunda gerçek hesabı gösterir.
export interface PanelIdentity {
  name: string;
  initials: string;
  email: string;
}

export function resolvePanelUser(user: User | null): PanelIdentity {
  const meta = user?.user_metadata ?? {};
  const fallbackName = user?.email ? user.email.split("@")[0] : "";
  const name = String(meta.ad_soyad || fallbackName || "");
  return {
    name,
    initials: initialsOf(name),
    email: user?.email ?? "",
  };
}
